"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WCSImg = void 0;
/**
 * @Description: 网宿云存储
 * @Version: 2.3.3
 * @Date: 2022-07-04 17:40:52
 */
var wcs_js_sdk_1 = require("@shopee-sz/wcs-js-sdk");
var types_1 = require("../types");
var utils_1 = require("./utils");
var WCSImg = /** @class */ (function (_super) {
    __extends(WCSImg, _super);
    function WCSImg(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        return _this;
    }
    WCSImg.prototype.cancel = function () { };
    WCSImg.prototype.upload = function (_a) {
        var file = _a.file, imgId = _a.imgId, imgIndex = _a.imgIndex;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var key = "".concat(imgId);
                        var uploader = (0, wcs_js_sdk_1.wcsUpload)(file, _this.options.token, _this.options.upload_domain, {
                            key: key,
                            mimeType: types_1.ContentTypeHeader.image,
                            retryCount: _this.options.strategy.retry_count,
                            concurrentRequestLimit: _this.options.strategy.concurrency
                        });
                        uploader.uploadProgress = function (_a) {
                            var total = _a.total;
                            // if (total.percent < 100) { // 拦住多余的一次ckunck回调
                            _this.options.onProgressCB(__assign(__assign({}, total), { percent: Math.round(total.percent) / 100, index: imgIndex, total: total.size }));
                        };
                        // }
                        uploader.onComplete = function (_a) {
                            var data = _a.data;
                            if (typeof data === 'string') {
                                resolve({
                                    url: _this.options.play_domain + '/' + key,
                                    etag: data,
                                    img_id: imgId,
                                    index: imgIndex
                                });
                            }
                            else {
                                resolve({
                                    url: _this.options.play_domain + '/' + key,
                                    etag: data.hash,
                                    img_id: imgId,
                                    index: imgIndex
                                });
                            }
                            return;
                        };
                        uploader.onError = reject;
                        _this.cancel = function () {
                            uploader.stop();
                        };
                        uploader.putFile();
                    })];
            });
        });
    };
    return WCSImg;
}(utils_1.ImgUploader));
exports.WCSImg = WCSImg;
